export const RightContentIconURL = "https://abmhosting.in/fastpass/homepage/avp4/assets/img/acces.jpg";
export const AwasBandhuURL = [
  {
    src: "https://www.awasbandhu.in/wp-content/themes/awasbandhu/images/logo.png",
    alt: "Awas Bandhu URL",
    link: "/",
  },
];

export const GovernmentOfUttarPradeshLogo = [
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg",
    alt: "Government of uttar pradesh logo",
    link: "/",
  },
];

export const GovtStripImages = [
  {
    src: "https://static.mygov.in/archive/g20/images/g20-logo.png",
    alt: "G20",
    link: "https://www.g20.org/en",
  },
  {
    src: "https://www.makeinindia.com/sites/default/files/mii.png",
    alt: "Make In India",
    link: "https://www.makeinindia.com/",
  },
  {
    src: "https://amritkaal.nic.in/writereaddata/Portal/images/logo-black.png",
    alt: "Azadi Ka Amrit Mahotsav",
    link: "https://amritkaal.nic.in/",
  },
  {
    src: "https://swachhbharatmission.ddws.gov.in/themes/custom/repo-theme-master/images/swach-bharat.png",
    alt: "Swachh Bharat",
    link: "https://swachhbharat.mygov.in/",
  },
];

export const bannerImgUrls = [
  // 'https://abmhosting.in/fastpass/homepage/avp4/assets/img/hero-carousel/hero-carousel-2.jpg',
  // "https://abmhosting.in/fastpass/homepage/avp4/assets/img/hero-carousel/hero-carousel-1.jpg",
  // 'https://abmhosting.in/fastpass/homepage/avp4/assets/img/hero-carousel/hero-carousel-3.jpg',

  // 'https://i.imgur.com/S3yCHvt.jpeg',
  // 'https://i.imgur.com/Kq5MXT0.jpeg',
  "https://i.ibb.co/Ndpv1djB/hero-carousel-2.jpg",
  "https://i.ibb.co/GqKyTrG/hero-carousel-1.jpg",
  "https://i.ibb.co/G43f5GNn/hero-carousel-3.jpg",

  //"https://abmhosting.in/fastpass/final/img/hero-carousel/hero-carousel-1.jpg",
];
export const fastpasinfoUrlbg = "https://abmhosting.in/fastpass/homepage/avp4/assets/img/about.jpg";
export const fastpasinfoUrlvideo = "https://abmhosting.in/fastpass/homepage/avp4/assets/img/about.jpg";

export const swipper = [
  "https://abmhosting.in/fastpass/homepage/avp4/assets/img/clients/client-1.png",
  "https://abmhosting.in/fastpass/homepage/avp4/assets/img/clients/client-2.png",
  "https://abmhosting.in/fastpass/homepage/avp4/assets/img/clients/client-3.png",
  "https://abmhosting.in/fastpass/homepage/avp4/assets/img/clients/client-4.png",
  "https://abmhosting.in/fastpass/homepage/avp4/assets/img/clients/client-5.png",
  "https://abmhosting.in/fastpass/homepage/avp4/assets/img/clients/client-6.png",
  "https://abmhosting.in/fastpass/homepage/avp4/assets/img/clients/client-7.png",
  "https://abmhosting.in/fastpass/homepage/avp4/assets/img/clients/client-8.png",
];
export const lucknowAddressImg = "https://i.imgur.com/Vr3eKcO.png";
